// SubDrawerActions.js
export const SET_SUB_DRAWER_OPEN = 'SET_SUB_DRAWER_OPEN';

export const setSubDrawerOpen = (routeName: any) => ({
    type: SET_SUB_DRAWER_OPEN,
    payload: routeName,
});
